module.exports = {
  env: {
    commonjs: true,
    es6: true,
    node: true,
    jest: true,
  },
  extends: ['airbnb-base', 'prettier'],
  globals: {
    Atomics: 'readonly',
    SharedArrayBuffer: 'readonly',
  },
  parserOptions: {
    ecmaVersion: 2018
  },
  rules: {
    quotes: ['error', 'single'],
    semi: ['error', 'never'],
    'import/no-dynamic-require': 'off',
    'no-nested-ternary': 'off',
    'max-len': 'off',
    'nonblock-statement-body-position': ['error', 'any'],
    'require-await': 'error',
    'no-unused-vars': ['error', { 'ignoreRestSiblings': true, 'argsIgnorePattern': '^_', 'caughtErrors': 'none' }],
    'camelcase': ['error', { 'ignoreDestructuring': true, 'allow': ['^server_key'] }],
    'no-unreachable': 'error',
    'key-spacing': ['error', { 'beforeColon': false }],
    'keyword-spacing': ['error', { 'after': true, 'before': true }],
    'arrow-parens': ['error', 'as-needed'],
    'arrow-spacing': ['error', { 'before': true, 'after': true }],
    'no-duplicate-imports': 'error',
    'no-var': 'error',
    'no-prototype-builtins': 'off',
    'dot-notation': 'off',
    'prefer-template': 'off',
    'no-else-return': 'off',
    'no-shadow': 'off',
    'no-unused-expressions': ['error', { 'allowTernary': true, 'allowShortCircuit': true }],
    'no-restricted-properties': 'off',
    'prefer-promise-reject-errors': 'off',
    'no-eval': 'off',
    'no-throw-literal': 'off',
    'prefer-destructuring': 'off',
    'no-param-reassign': 'off',
    'eqeqeq': ['error', 'smart'],
    'no-console': 'off',
    'no-useless-escape': 'off',
    'no-return-assign': 'off',
    'no-underscore-dangle': 'off',
    'no-restricted-globals': 'off',
    'no-useless-catch': 'off',
    'global-require': 'off',
    'no-async-promise-executor': 'off',
    'no-plusplus': 'off',
    'prefer-const': ['error', { 'destructuring': 'all', 'ignoreReadBeforeAssign': true }],
    'default-case': 'off',
    'no-use-before-define': ['error', { 'functions': false, 'variables': false }],
    'no-irregular-whitespace': ['error', { 'skipComments': true }],
    'radix': 'off',
    'arrow-body-style': 'off'
  },
}
